// usePermissions — client-side permission check from context token
//
// The context token JWT payload includes a `permissions` array which is
// resolved by platform-api when issuing the token:
//   - All permissions from the user's role_permissions
//   - Minus any user_permission_overrides with granted=false
//   - Plus any user_permission_overrides with granted=true
//
// Usage:
//   const { can } = usePermissions()
//   if (can('plans.create')) { ... }

export function usePermissions() {
  try {
    const token = localStorage.getItem('ember_context_token')
    if (!token) return { can: () => false }

    const parts = token.split('.')
    if (parts.length !== 3) return { can: () => false }

    // Decode JWT payload (base64url → base64 → JSON)
    const base64 = parts[1]!.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
    const payload = JSON.parse(atob(padded))

    // permissions array is included in context token by platform-api
    const userPermissions: string[] = payload.permissions ?? []

    return {
      can: (permission: string) => userPermissions.includes(permission),
    }
  } catch {
    return { can: () => false }
  }
}
